import { URLBACKEND, API } from '@app/config/constants';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { CsrfService } from '@app/services/csrf.service';

@Injectable()
export class PlantillasService {
  private _http = inject(HttpClient);
  private csrfService = inject(CsrfService);

  crear(file: File, parametros: Record<string, string | number>): Observable<string> {
    const formData = new FormData();

    Object.keys(parametros).forEach((key) => {
      formData.append(key, String(parametros[key]));
    });

    if (this.csrfService.token) {
      formData.append('_csrf', this.csrfService.token);
    }
    formData.append('documento', file);

    return this._http.post(URLBACKEND + API + 'plantillas/crear', formData, {
      withCredentials: true,
      responseType: 'text',
    });
  }

  editar(file: File, parametros: Record<string, string | number>): Observable<string> {
    const formData = new FormData();

    Object.keys(parametros).forEach((key) => {
      formData.append(key, String(parametros[key]));
    });

    if (this.csrfService.token) {
      formData.append('_csrf', this.csrfService.token);
    }
    formData.append('documento', file);

    return this._http.put(URLBACKEND + API + 'plantillas/editar', formData, {
      withCredentials: true,
      responseType: 'text',
    });
  }
}
